import { render, staticRenderFns } from "./manageOpen.vue?vue&type=template&id=5b275ab3&scoped=true&"
import script from "./manageOpen.vue?vue&type=script&lang=js&"
export * from "./manageOpen.vue?vue&type=script&lang=js&"
import style0 from "./manageOpen.vue?vue&type=style&index=0&id=5b275ab3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b275ab3",
  null
  
)

export default component.exports